import {Button} from '@/components/ui/button/Button'
import {Bell01Icon} from '@/components/ui/icon/Icon'
import {NotificationsModal} from '@/features/notifications/components/notifications-modal/NotificationsModal'
import {useNotificationsPanelStore} from '@/features/notifications/store/useNotificationsPanelStore'
import {NotificationBadge} from '../notification-badge/NotificationBadge'

export const NotificationButton = () => {
    const openPanel = useNotificationsPanelStore(state => state.open)

    return (
        <>
            <NotificationBadge onNotificationClickCb={openPanel}>
                <Button variant="ghost" size="sm" shape="square">
                    <Bell01Icon />
                </Button>
            </NotificationBadge>
            <NotificationsModal />
        </>
    )
}
